import { ReactNode } from 'react'

export type FormControlProps = {
  name: string
  children: ReactNode
  label?: string
  description?: string
  error?: string | Record<string, string>
}

export function FormControl({ name, children, label, description, error }: FormControlProps) {
  return (
    <div className="flex flex-col items-start justify-start w-full">
      {(label || description) && (
        <div className="flex flex-col items-start justify-start w-full">
          {label && (
            <label
              htmlFor={name}
              className="w-full pb-1 my-0 text-base font-medium !text-left text-basic"
            >
              {label}
            </label>
          )}
          {description && <span className="text-xs font-light">{description}</span>}
        </div>
      )}
      <div className="w-full">{children}</div>
      {error && (
        <span className="w-full text-sm text-error">
          {typeof error === 'string' ? error : Object.values(error)[0]}
        </span>
      )}
    </div>
  )
}
